import _toConsumableArray from '../../../../node_modules/@babel/runtime/helpers/toConsumableArray.es.js';
import _defineProperty from '../../../../node_modules/@babel/runtime/helpers/defineProperty.es.js';
import _slicedToArray from '../../../../node_modules/@babel/runtime/helpers/slicedToArray.es.js';
import React, { useRef, useState, useMemo } from 'react';
import { ConfirmModal } from './ConfirmModal.es.js';
import { ConfirmModalContext } from './ConfirmModalContext.es.js';

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function ConfirmModalContextProvider(props) {
  var uid = useRef(0);

  var _useState = useState([]),
      _useState2 = _slicedToArray(_useState, 2),
      state = _useState2[0],
      setState = _useState2[1];

  function close(modal) {
    setState(function (st) {
      return st.map(function (m) {
        return m.id === modal.id ? _objectSpread(_objectSpread({}, m), {}, {
          open: false
        }) : m;
      });
    });
  }

  function unmount(modal) {
    setState(function (st) {
      return st.filter(function (m) {
        return m.id !== modal.id;
      });
    });
  }

  var contextValue = useMemo(function () {
    function open(openOptions) {
      uid.current += 1;
      var id = "".concat(uid.current);
      var modal = {
        id: id,
        open: true,
        openOptions: openOptions
      };
      setState(function (st) {
        return [].concat(_toConsumableArray(st), [modal]);
      });

      function dismiss() {
        close(modal);
      }

      return {
        dismiss: dismiss
      };
    }

    return {
      open: open
    };
  }, []);

  function handleDismiss(modal) {
    close(modal);

    if (modal.openOptions.onDismiss) {
      modal.openOptions.onDismiss();
    }
  }

  function handleSubmit(modal, result) {
    close(modal);

    if (modal.openOptions.onSubmit) {
      modal.openOptions.onSubmit(result);
    }
  }

  function handleCloseEnd(modal) {
    unmount(modal);
  }

  return /*#__PURE__*/React.createElement(ConfirmModalContext.Provider, {
    value: contextValue
  }, props.children, state.map(function (modal) {
    return /*#__PURE__*/React.createElement(ConfirmModal, Object.assign({
      key: modal.id,
      open: modal.open
    }, modal.openOptions, {
      onDismiss: function onDismiss() {
        return handleDismiss(modal);
      },
      onSubmit: function onSubmit(result) {
        return handleSubmit(modal, result);
      },
      onCloseEnd: function onCloseEnd() {
        return handleCloseEnd(modal);
      }
    }));
  }));
}
ConfirmModalContextProvider.displayName = 'ConfirmModalContextProvider';

export { ConfirmModalContextProvider };
